import { EventTypeListItem } from "./EventTypeListItem";
import { Logo } from "./Logo";
import React, { useCallback, useState, useEffect } from "react";
import './EventTypePicker.css';
import { GUEST_USER_ID, eventTypes } from "../constants";
import { useHistory } from "react-router-dom";

  
export const EventTypePicker = ({  }) => {
    const history = useHistory();

    const [appState, setAppState] = useState(null);

    // https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/rooms
    useEffect(() => {
        // ask aws lambda
        fetch('https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/rooms')
            .then((response) => {
                return response.json();
            })
            .then((fullState) => {
                setAppState(fullState);
            });
    }, [setAppState]);


    const onSelect = useCallback((eventType) => {
        // ask aws lambda
        fetch('https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/rooms/' + eventType.id + '?clientId=' + GUEST_USER_ID)
            .then((response) => {
                return response.json();
            })
            .then((room) => {
                history.push('/room/' + eventType.id + '/' + room.name);
            });
    }, [history]);

    return <div className='fullscreen f-centered'>
        <div className='event-type-picker'>
            
            <Logo />
            
            <div className=''>
                Welcome to our online co-working space.
            </div>
            
            <div className='event-type-picker__prompt'>
                Pick the type of room you want to join
            </div>
            <div className='event-type-list'>
                {eventTypes.filter(x => !x.hideFromNavigation).map(x => <EventTypeListItem key={x.name} appState={appState} eventType={x} onSelect={onSelect} />)}
            </div>
        </div>

    </div>;
};
